import {
  ResultsData,
  FilterList,
  Bus,
  DepartureTime,
} from "../../../app/bus/results/types";

export interface SelectedFilters {
  [key: string]: (string | number | DepartureTime)[];
}

export interface GovtBuses {
  [key: string]: Bus[];
}

export interface NoResultsFound {
  type: {
    TYPE: string;
    TITLE: string;
    MESSAGE: string;
  };
  value: boolean;
}
export interface ResultsStore {
  resultsData: ResultsData | Record<string, never>;
  filterResults: ResultsData | Record<string, never>;
  filterList: {
    [key: string]: FilterList[];
  };
  [key: string]: any;
  selectedFilters: SelectedFilters;
  showFilters: boolean;
  noResultsFound: NoResultsFound;
  govtBuses: GovtBuses;
  filteredGovtBuses: GovtBuses;
  resultsLoading: boolean;
  showSeatLayout: boolean;
}
export interface ResultsContextType extends ResultsStore {
  setResultsData: (results: ResultsData) => void;
  setListOptions: (item: {
    amenities: FilterList[];
    pickupPoints: FilterList[];
    dropOffPoints: FilterList[];
    busOperators: FilterList[];
  }) => void;

  applyFilters: (
    newFilterResults: ResultsData,
    newFilteredGovtBuses: GovtBuses,
    newFilterList: Record<string, FilterList[]>
  ) => void;
  setShowFilters: () => void;
  setNoResultsFound: (item: NoResultsFound) => void;
  setGovtBuses: (item: GovtBuses) => void;
  setSelectedFilters: (item: SelectedFilters) => void;
  clearContextData: () => void;
  setResultsLoading: (val: boolean) => void;
  setShowSeatLayout: (va: boolean) => void;
}

export enum Types {
  SET_RESULTS_DATA = "SET_RESULTS_DATA",
  SET_SHOW_FILTERS = "SET_SHOW_FILTERS",
  SET_FILTERS_WITH_OPTIONS = "SET_FILTERS_WITH_OPTIONS",
  APPLY_FILTERS = "APPLY_FILTERS",
  NO_RESULTS_FOUND = "NO_RESULTS_FOUND",
  SET_FILTER_LIST = "SET_FILTER_LIST",
  SET_GOVT_BUSES = "SET_GOVT_BUSES",
  SET_FILTERED_GOVT_BUSES = "SET_FILTERED_GOVT_BUSES",
  CLEAR_CONTEXT_DATA = "CLEAR_CONTEXT_DATA",
  SET_SELECTED_FILTERS = "SET_SELECTED_FILTERS",
  SET_RESULTS_LOADING = "SET_RESULTS_LOADING",
  SET_SHOW_SEAT_LAYOUT = "SET_SHOW_SEAT_LAYOUT",
}
